export const COLORS = {
  main1: "#20C997",
  secondary1: "#091540",
  blue: "#7692FF",
  white: "#FEFCFD",
  gray: "#EFEFEF",
  black1: "#181818",
  "light-gray": "#F7F7F8",
  main2: "#FFAC72",
  "bg-text-color": "#737B8B",
  warning: "#FF5C77",
  "light-blue": "#E8EDFF",
  "light-green": "rgba(50, 147, 111, 0.16)",
  "light-warning": "rgba(255, 92, 119, 0.16)",
  "light-bg-color": "#DADDE7",
  "light-orange": "rgba(255, 172, 114, 0.16)",
  "half-gray": "#BDC0C7"
};
